
import config from '../config.json'
import konsole from '../network/konsole';
import { $CommonServiceFn } from '../network/Services';


  export const isValidFuntion = (data) => {
    if (data !== undefined && data !== null && data !== "") {
      return true
    } else {
      return false
    }
  };

  export const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
}

export const formatDateIntoDDMMYY = (inputDate) =>{
const date = new Date(inputDate);

const day = date.getDate().toString().padStart(2, '0');
const month = (date.getMonth() + 1).toString().padStart(2, '0');
const year = date.getFullYear().toString();

return`${month}/${day}/${year}`;

}

export function formatDateToMMDDYY(dateString) {
  if (!dateString) return "";

  const parts = dateString.split("-");
  if (parts.length !== 3) return "";

  const year = parts[0];
  const month = parts[1];
  const day = parts[2];

  return `${month}-${day}-${year}`;
}

export const formatDateIntoIndia = (inputDate) =>{
const date = new Date(inputDate);

const day = date.getDate().toString().padStart(2, '0');
const month = (date.getMonth() + 1).toString().padStart(2, '0');
const year = date.getFullYear().toString();

return`${day}-${month}-${year}`;

}

export const demo = config.demo;


export const isAlphabetRegex2 = (string) => {
  let regex = /^[a-zA-Z-,0-9,& ]+$/;
  return regex.test(string);
}
export const isNumberRegex = (value) => {
  let regex = /^[0-9]*$/;
  return regex.test(value);
}
export const isNullUndefine = (value) => {
  if (value == undefined || value == null || value == '') {
    return true;
  }
  return false
}
export const formatPhoneNumber = (mobileNumber) => {
    const contactNumber = mobileNumber;
    function formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");

      if (cleaned?.startsWith("254")) {
        return ` ${cleaned?.slice(3, 6) + " " + cleaned?.slice(6, 9) + " " + cleaned?.slice(9)}`
      }
      else {
        let contactNumber = cleaned?.slice(-10)
        let match = contactNumber?.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
      }
    }
    if (contactNumber) {
      if (contactNumber?.slice(0, 3) == +91) {
        return contactNumber?.slice(0, 3) + formatPhoneNumber(contactNumber)
      }
      else if (contactNumber?.slice(0, 4) == +254) {
        return contactNumber?.slice(0, 4) + formatPhoneNumber(contactNumber)
      }
      else {
        return contactNumber?.slice(0, 2) + formatPhoneNumber(contactNumber)
      }
    }
    else {
      return ""
    }
  }
 export const newPhoneNumberFormat= (mobileNumber) => {
    const contactNumber = mobileNumber;
    function formatPhoneNumber(str) {
      let cleaned = ("" + str).replace(/\D/g, "");
      // konsole.log("dsdasdsds",str,cleaned?.startsWith("+254"),cleaned)
      if (cleaned?.startsWith("254")) {
        return ` ${cleaned?.slice(3, 6) + " " + cleaned?.slice(6, 9) + " " + cleaned?.slice(9)}`
      }
      else {
        let contactNumber = cleaned?.slice(-10)
        let match = contactNumber?.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
          return "(" + match[1] + ") " + match[2] + "-" + match[3];
        }
        return null;
      }
    }
    // konsole.log("mobileNumbermobileNumber",mobileNumber)
    if (contactNumber) {
      if (contactNumber?.slice(0, 3) == +91) {
        return contactNumber?.slice(0, 3) + formatPhoneNumber(contactNumber)
      }
      else if (contactNumber?.slice(0, 4) == +254) {
        return contactNumber?.slice(0, 4) + formatPhoneNumber(contactNumber)
      }
      else {
        return contactNumber?.slice(0, 2) + formatPhoneNumber(contactNumber)
      }
    }
    else {
      return ""
    }
  }

  export default function formatUSPhoneNumber(value) {
  // Remove all non-digit characters
  const digits = value.replace(/\D/g, '').substring(0, 10);

  const areaCode = digits.slice(0, 3);
  const middle = digits.slice(3, 6);
  const last = digits.slice(6, 10);

  if (digits.length > 6) {
    return `(${areaCode}) ${middle}-${last}`;
  } else if (digits.length > 3) {
    return `(${areaCode}) ${middle}`;
  } else if (digits.length > 0) {
    return `(${areaCode}`;
  }

  return '';
}

export function limitPercentage(value) {
  if (typeof value === 'string') {
    value = value.replace(/[^\d.]/g, ''); // Remove non-numeric characters
  }

  let num = parseFloat(value);

  if (isNaN(num)) return '';

  // Clamp value between 0 and 100
  num = Math.max(0, Math.min(100, num));

  // Limit to fixed decimal places
  return parseFloat(num.toFixed(2));
}

export function separateCountryCodeAndNumber(phone) {
  if (!phone) return { countryCode: '', number: '' };

  // Remove non-digit characters
  const digits = phone.replace(/\D/g, '');

  // USA (10-digit number), country code +1
  if (digits.length === 11 && digits.startsWith('1')) {
    return {
      countryCode: '+1',
      number: digits.slice(1),
    };
  }

  // India (10-digit number), country code +91
  if (digits.length === 12 && digits.startsWith('91')) {
    return {
      countryCode: '+91',
      number: digits.slice(2),
    };
  }

  // Fallback: assume no country code
  return {
    countryCode: '',
    number: digits,
  };
}

const sessionSubtenantId = Number(sessionStorage.getItem('SubtenantId')) || 742;
export const lplSubtinent =  [3,742].includes(sessionSubtenantId) ? 742 :sessionSubtenantId
export const time_mattersSubtinent = 988
export const federal_way_plazaId =  config?.demo ==  true ? 989 : 760
export const subtenantId4AttorneyReport = config?.demo ==  true ? 742 : 742;

export const isNotValidNullUndefile = (value) => {
  if (value !== undefined && value !== null && value !== '') {
    return true;
  }
  return false
}

export const isNotValidNullUndefileInstallmentAmount = (value) => {
  if (value !== undefined && value !== null && value !== '' && value != 0) {
    return true;
  }
  return false
}

export const isValidExpiry = ( expiryDate, comparisonDate = new Date(),  afterNoOfDays = 0 ) => {
    // konsole.log("isValidExpiry expiryDate ", expiryDate, " comparisonDate ", comparisonDate);
    if(!expiryDate) return false;

    let [ month, year ] = expiryDate?.split('/');
    month = Number(month);
    year = (year?.length == 4) ? (year) : (year?.length == 2) ? ("20" + year) : "";
    year = Number(year);

    // konsole.log("isValidExpiry ", month, " / ", year);

    if(!month || !year || isNaN(month) || isNaN(year)) return false;

    const _actualExpiryDate = new Date(year, month, 0);
    const _comparisonDate = parseDateSafely(comparisonDate?.toISOString?.() || comparisonDate)
    const _actualComparisonDate = new Date(
        _comparisonDate.getFullYear(),
        _comparisonDate.getMonth(),
        _comparisonDate.getDate() + afterNoOfDays
    );

    // konsole.log("isValidExpiry tabConsole", _actualExpiryDate , _comparisonDate, _actualComparisonDate);

    return _actualExpiryDate >= _actualComparisonDate;
  }
   export const getFirstAndLastName =( fullName ) => {
        if(!fullName) return "";

        fullName = fullName?.trim();
        const lastSpaceIndex = fullName?.lastIndexOf(" ");

        if(lastSpaceIndex == -1) return { firstName: fullName, lastName: fullName }

        const firstName = fullName?.substring(0, lastSpaceIndex).trim();
        const lastName = fullName?.substring(lastSpaceIndex + 1).trim();

        return { firstName, lastName };
    }
    export const getCardCompany = ( cardNumber ) => {
        let cardType;
        let imgPath;
        let unformattedNum = cardNumber?.replaceAll(" ", "");

        if (/^4/.test(unformattedNum)) {
            cardType = 'Visa';
            imgPath = '/New/newIcons/card.png';
        } else if (/^5[1-5]/.test(unformattedNum)) {
            cardType = 'Mastercard';
            imgPath = '/New/newIcons/card.png';
        } else if (/^3[47]/.test(unformattedNum)) {
            cardType = 'Amex';
            imgPath = '/New/newIcons/card.png';
        } else if (/^(6011|65|64[4-9])/.test(unformattedNum)) {
            cardType = 'Discover';
            imgPath = '/New/newIcons/card.png';
        } else if (/^35/.test(unformattedNum)) {
            cardType = 'JCB';
            imgPath = '/New/newIcons/card.png';
        } else if (/^(30[0-5]|36|38)/.test(unformattedNum)) {
            cardType = 'Diners';
            imgPath = '/New/newIcons/card.png';
        } else {
            cardType = 'Card';
            imgPath = '/New/newIcons/card.png';
        }

        return { cardType, imgPath};
    }
    export const $isNotNullUndefine = (val) => {
        if (val !== undefined && val !== null && val !== '') {
            return true;
        }
        return false;
    }
    export const isNumberAndSpaceRegex = (value) => {
        let regex = /^[\d\s]{0,19}$/;
        return regex.test(value);
    }
    export const isNumberAndSlash = (date) => {
        const regex = /^[0-9\/]*$/; // MM/YY format
        return regex.test(date);
    }
    export const isNotallowspecialRegex = (value) => {
        let regex = /^[A-Za-z0-9 ]+$/;
        return regex.test(value);
    }
    export const capitalizeFirstLetter = (string) => {
         // return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : '';
         return string ? string.charAt(0).toUpperCase() + string.slice(1) : '';
    }
    export const $Msg_AddressDetails = {
    cityErr: "City is required",
    countryErr: "Country is required",
    aptErr: "Apartment is required",
    stateErr: "State is required",
    zipcodeErr: "ZipCode is required",
    zipCodeErr: "ZipCode is required",
    addressTypeErr: "Address type is required",
    addressTypeIdErr: "Address type is required",
    countyErr: "County is required",
    countyRefrenceErr: "County Refrence is required",
    addressLine1Err: "Address is required",
    otherErr: "Other description is required",
    emailErr: "Email is required",
    contactTypesErr: "Contact type is required",
    contactTypeErr: "Contact type is required",
    contactTypeIdErr: "Contact type is required",
    mobileErr: "Mobile number is required",
    comeTypeErr: "Communication Type is required",
    streetAddressErr:' Billing address is required',
    expireDateErr:"Expiration date is required",
    cardNumberErr:"Card number required",
    cardNickNameErr:"Cardholder name is required",
    cardCvvErr:"CVV  is required"
}
export const initMapScript = () => {
    if (window.google) {
        return Promise.resolve();
    }
    const src = `https://maps.googleapis.com/maps/api/js?key=${'AIzaSyBaUn22pwovCzOxH7Uthivbd8_ScMkaEAI'}&libraries=places&v=weekly`;

    return loadAsyncScript(src);
}
export const loadAsyncScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            Object.assign(script, {
                type: "text/javascript",
                async: true,
                src
            });
            script.addEventListener("load", () => resolve(script));
            document.head.appendChild(script);
        });
    }
  export const parseDateSafely = (dateStr) => {
    if (!dateStr) return null;
    const normalizedDateStr = dateStr?.includes("T") ? dateStr : `${dateStr}T00:00:00Z`;

    const date = new Date(normalizedDateStr);
    if (isNaN(date.getTime())) {
        const parts = dateStr.split(/[-/]/);
        if (parts.length === 3) {
            const [part1, part2, part3] = parts.map((p) => p.padStart(2, '0'));
            const isoDate = `${part3}-${part1}-${part2}T00:00:00Z`;
            const safariSafeDate = new Date(isoDate);
            if (!isNaN(safariSafeDate.getTime())) return safariSafeDate;
        }
        return null;
    }
    return date;
  }
  export const userCardJson = () => {
        return {
            id: 0, userProfileId: 0, cardNickName: "", paymentProfileId: "", customerProfileId: "",
            cardNumber: "", expireDate: "", cardType: "", cardIsDeleted: false, isDefault: false, streetAddress: "",
            apartmentNo: "", city : "", state: "", zipCode: "", cardIsActive: true, remarks: "", createdBy: "",
            updatedBy :"" , userLoginId:"", userId:"", firstName:"" , lastName:"", emailId:"" , phoneNumber:""
        }
    }
    export const getDateFormatted =( dateNTime ) => {
        const _dateNTime = new Date(dateNTime)
        const month = _dateNTime.toLocaleString('default', { month: 'long' });
        const date = _dateNTime.getDate();
        const year = _dateNTime.getFullYear();

        return `${month} ${date}, ${year}`;
    }
  export const getApiCall = (method, url, setState) => {
  return new Promise((resolve, reject) => {
    $CommonServiceFn.InvokeCommonApi(method, url, '', (res, err) => {
      if (res) {
        // console.log('res of fetching', url, res, 'data');
        if (setState) {
          setState(res?.data?.data);
        }
        resolve(res?.data?.data);
      } else {
        konsole.log('res in fetching', url, err);
        if (setState) {
          setState([]);
        }
        resolve('err');
      }
    });
  });
}

export const removeCommas = (numberStr) => {
  try {
    if (typeof numberStr !== 'string') {
      // If it's not a string, convert to string if possible
      if (numberStr === null || numberStr === undefined) return '';
      numberStr = String(numberStr);
    }
    return numberStr.replace(/,/g, '');
  } catch (error) {
    // In case any unexpected error happens, return empty string
    console.error("removeCommas error:", error);
    return '';
  }
};

export const formatToUS = (value) => {
    // console.log(value,"valuevaluevaluevaluevalue")
    if (!value) return "";
    let cleaned = value?.replace(/,/g, "");

    if (!/^\d*\.?\d{0,2}$/.test(cleaned)) {
      return null;
    }

    const parts = cleaned.split(".");
    let integerPart = parts[0];
    const decimalPart = parts[1] !== undefined ? parts[1] : null;

    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    if (decimalPart === null) {
      return integerPart;
    } else {
      return integerPart + "." + decimalPart;
    }
  }
  export const convertToUSFormat = (isoDate) => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  return `${month}/${day}/${year}`; // MM/DD/YYYY
};

export const receiptCashpaymentGeneral = "<html><head><meta charset=\"UTF-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"><title>Invoice Receipt</title></head><body style=\"font-family: Arial, sans-serif; margin: 20px; background-color: #f5f5f5;\"><div style=\"max-width: 600px; margin: 0 auto; background-color: white; border: 2px solid #000; padding: 20px;\"><div style=\"margin-bottom: 20px;\"><h2 style=\"margin: 0; font-size: 18px; font-weight: bold;\">Merchant: LIFE POINT LAW General Account</h2><div style=\"margin-top: 10px;\"><div>31919 6TH AVE S #A100</div><div>FEDERAL WAY, WA 98003</div><div>USA</div></div><div style=\"right: 40px; top: 40px; font-weight: bold;\">+1(253) 838-3454</div></div><div style=\"margin-bottom: 20px;\"><div style=\"color: #666; font-size: 12px;\">Order Information</div><table style=\"width: 100%; border-collapse: collapse; margin-top: 10px;\"><tr><td style=\"width: 50%; padding: 5px 0;\"><strong>Description: </strong><span>@@PRODUCTNAME</span></td></tr><tr><td style=\"padding: 5px 0;\"><strong>Order Number: </strong><span>@@ORDERID</span></td><td style=\"padding: 5px 0;\"><strong>P.O. Number:</strong><span>@@PONUMBER</span></td></tr><tr><td style=\"padding: 5px 0;\"><strong>Customer ID:</strong><span>@@CUSTOMERID</span></td><td style=\"padding: 5px 0;\"><strong>Invoice Number:</strong><span>@@INVOICENUMBER</span></td></tr></table></div><table style=\"width: 100%; margin-bottom: 20px;\"><tr><td style=\"width: 48%; vertical-align: top;\"><div style=\"font-weight: bold; margin-bottom: 10px;\">Billing Information</div><div>@@CLIENTNAME</div><div>@@ADDRESSLINE1</div><div>@@CITYSTATEZIP</div><div>@@COUNTRY</div><div>Phone: @@CLIENTPHONE</div><div>@@CLIENTEMAIL</div></td><td style=\"width: 48%; vertical-align: top;\"></td></tr></table><div style=\"text-align: right; margin-bottom: 20px;\"><table style=\"width: 100%; border-collapse: collapse;\"><tr><td style=\"text-align: right; padding: 5px 0;\">Shipping:</td><td style=\"text-align: right; padding: 5px 0; width: 100px;\">0.00</td></tr><tr><td style=\"text-align: right; padding: 5px 0;\">Tax:</td><td style=\"text-align: right; padding: 5px 0;\">0.00</td></tr><tr style=\"font-weight: bold; font-size: 16px;\"><td style=\"text-align: right; padding: 10px 0; border-top: 1px solid #000;\">Total:</td><td style=\"text-align: right; padding: 10px 0; border-top: 1px solid #000;\">USD @@TOTALPAID</td></tr></table></div><div style=\"margin-bottom: 20px;\"><div style=\"color: #666; font-size: 12px; margin-bottom: 10px;\">Payment Information</div><table style=\"width: 100%; border-collapse: collapse;\"><tr><td style=\"width: 50%; padding: 5px 0;\"><strong>Date/Time:</strong></td><td style=\"padding: 5px 0;\">@@PAYMENTTIME</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Transaction ID:</strong></td><td style=\"padding: 5px 0;\">@@TRANSACTIONID</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Transaction Type:</strong></td><td style=\"padding: 5px 0;\">@@TRANSACTIONTYPE</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Transaction Status:</strong></td><td style=\"padding: 5px 0; font-weight: bold;\">@@TRANSACTIONSTATUS</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Authorization Code:</strong></td><td style=\"padding: 5px 0;\">@@AUTHORIZATIONCODE</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Payment Method:</strong></td><td style=\"padding: 5px 0;\">@@CARDNUMBER</td></tr>                                           <tr><td style=\"padding: 5px 0;\"><strong>Check Number:</strong></td><td style=\"padding: 5px 0;\">@@CHECKNUMBER</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Check Date:</strong></td><td style=\"padding: 5px 0;\">@@CHECKDATE</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Account Name:</strong></td><td style=\"padding: 5px 0;\">@@ACCOUNTNAME</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Account Number:</strong></td><td style=\"padding: 5px 0;\">@@ACCOUNTNUMBER</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Routing Number:</strong></td><td style=\"padding: 5px 0;\">@@ROUTINGNUMBER</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Bank Name:</strong></td><td style=\"padding: 5px 0;\">@@BANKNAME</td></tr></table></div></div></body></html>"
export const receiptCashpaymentIOLTA = "<html><head><meta charset=\"UTF-8\"><meta name=\"viewport\" content=\"width=device-width, initial-scale=1.0\"><title>Invoice Receipt</title></head><body style=\"font-family: Arial, sans-serif; margin: 20px; background-color: #f5f5f5;\"><div style=\"max-width: 600px; margin: 0 auto; background-color: white; border: 2px solid #000; padding: 20px;\"><div style=\"margin-bottom: 20px;\"><h2 style=\"margin: 0; font-size: 18px; font-weight: bold;\">Merchant: LIFE POINT LAW IOLTA Account</h2><div style=\"margin-top: 10px;\"><div>31919 6TH AVE S #A100</div><div>FEDERAL WAY, WA 98003</div><div>USA</div></div><div style=\"right: 40px; top: 40px; font-weight: bold;\">+1(253) 838-3454</div></div><div style=\"margin-bottom: 20px;\"><div style=\"color: #666; font-size: 12px;\">Order Information</div><table style=\"width: 100%; border-collapse: collapse; margin-top: 10px;\"><tr><td style=\"width: 50%; padding: 5px 0;\"><strong>Description: </strong><span>@@PRODUCTNAME</span></td></tr><tr><td style=\"padding: 5px 0;\"><strong>Order Number: </strong><span>@@ORDERID</span></td><td style=\"padding: 5px 0;\"><strong>P.O. Number:</strong><span>@@PONUMBER</span></td></tr><tr><td style=\"padding: 5px 0;\"><strong>Customer ID:</strong><span>@@CUSTOMERID</span></td><td style=\"padding: 5px 0;\"><strong>Invoice Number:</strong><span>@@INVOICENUMBER</span></td></tr></table></div><table style=\"width: 100%; margin-bottom: 20px;\"><tr><td style=\"width: 48%; vertical-align: top;\"><div style=\"font-weight: bold; margin-bottom: 10px;\">Billing Information</div><div>@@CLIENTNAME</div><div>@@ADDRESSLINE1</div><div>@@CITYSTATEZIP</div><div>@@COUNTRY</div><div>Phone: @@CLIENTPHONE</div><div>@@CLIENTEMAIL</div></td><td style=\"width: 48%; vertical-align: top;\"></td></tr></table><div style=\"text-align: right; margin-bottom: 20px;\"><table style=\"width: 100%; border-collapse: collapse;\"><tr><td style=\"text-align: right; padding: 5px 0;\">Shipping:</td><td style=\"text-align: right; padding: 5px 0; width: 100px;\">0.00</td></tr><tr><td style=\"text-align: right; padding: 5px 0;\">Tax:</td><td style=\"text-align: right; padding: 5px 0;\">0.00</td></tr><tr style=\"font-weight: bold; font-size: 16px;\"><td style=\"text-align: right; padding: 10px 0; border-top: 1px solid #000;\">Total:</td><td style=\"text-align: right; padding: 10px 0; border-top: 1px solid #000;\">USD @@TOTALPAID</td></tr></table></div><div style=\"margin-bottom: 20px;\"><div style=\"color: #666; font-size: 12px; margin-bottom: 10px;\">Payment Information</div><table style=\"width: 100%; border-collapse: collapse;\"><tr><td style=\"width: 50%; padding: 5px 0;\"><strong>Date/Time:</strong></td><td style=\"padding: 5px 0;\">@@PAYMENTTIME</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Transaction ID:</strong></td><td style=\"padding: 5px 0;\">@@TRANSACTIONID</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Transaction Type:</strong></td><td style=\"padding: 5px 0;\">@@TRANSACTIONTYPE</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Transaction Status:</strong></td><td style=\"padding: 5px 0; font-weight: bold;\">@@TRANSACTIONSTATUS</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Authorization Code:</strong></td><td style=\"padding: 5px 0;\">@@AUTHORIZATIONCODE</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Payment Method:</strong></td><td style=\"padding: 5px 0;\">@@CARDNUMBER</td></tr>                                           <tr><td style=\"padding: 5px 0;\"><strong>Check Number:</strong></td><td style=\"padding: 5px 0;\">@@CHECKNUMBER</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Check Date:</strong></td><td style=\"padding: 5px 0;\">@@CHECKDATE</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Account Name:</strong></td><td style=\"padding: 5px 0;\">@@ACCOUNTNAME</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Account Number:</strong></td><td style=\"padding: 5px 0;\">@@ACCOUNTNUMBER</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Routing Number:</strong></td><td style=\"padding: 5px 0;\">@@ROUTINGNUMBER</td></tr><tr><td style=\"padding: 5px 0;\"><strong>Bank Name:</strong></td><td style=\"padding: 5px 0;\">@@BANKNAME</td></tr></table></div></div></body></html>"

export const formatDatePDT = () => {
  const date = new Date();

      const options = {
      timeZone: 'America/Los_Angeles',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      timeZoneName: 'short' // Gives PDT or PST
    };

    // Format to parts
    const parts = new Intl.DateTimeFormat('en-US', options).formatToParts(date);

    // Extract parts into a flat object
    const formatted = {};
    parts.forEach(({ type, value }) => {
      formatted[type] = value;
    });

    // Construct output manually
    const output = `${formatted.month}-${formatted.day}-${formatted.year} ${formatted.hour}:${formatted.minute}:${formatted.second} ${formatted.timeZoneName}`;
    // console.log(output);

    return output;
}

export const capitalizeFirst = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const appendFormData = (objData) => {
        const formData = new FormData();
        for (const key in objData) {
            if (objData.hasOwnProperty(key) && (objData[key])) {
                formData.append(key, objData[key]);
            }
        }
        return formData;

    }
    //  in file cabinet folder struce based on parent id
export const createNestedArray = (folders) => {
  konsole.log('folders', folders)
  const nestedArray = [];

  function buildNestedArray(parentId, level) {
    const folder = folders?.filter(folder => folder?.parentFolderId === parentId);
    if (folder?.length === 0 || folder == undefined || folder == null) { return []; }

    const nestedChildren = folder.map(child => {
      return {
        ...child,
        folder: buildNestedArray(child.folderId, level + 1)
      };
    });
    return nestedChildren;
  }
  nestedArray.push(...buildNestedArray(0, 1));
  return nestedArray;
}
export const formatName = (name = "") => {
  if (!isNotValidNullUndefile(name)) return "";

  return name.split(/\s+/).map(word => {
      if (!word) return "";
      return word[0].toUpperCase() + word.slice(1); // keep rest as user typed
    }).join(" ");
};

export const Authtoken = ''

export const reportViewableUserIds = [
  "73D5FD90-792E-4156-BCBF-33922100BDC9", // Vishnu UAT
  "706cde47-5215-42f4-8d0c-8d8b0f3dcbba", // Satyam UAT
  "1931fdad-5ef6-43e4-94d0-a88f5278e05b", // Abhishek UAT
  "0C085CA4-0E4E-451F-BF9A-32764CF091A4", // Maria Volosenko PROD
  "9E6EA069-3EFF-429A-8FFD-6A082F1C72B3", // Rajiv Nagaich PROD
  "40342820-6BDF-48CE-BCA9-8D9E17D50132", // Jamie Leone Nagaich PROD
  "A4C6085F-6A0E-450C-B55F-A387F4378CE4", // Prem Mohan Singh PROD
  "9F06F3EA-B161-4821-9C9E-FD9E24C65F1D", // Jennifer Munsch PROD
  "d17714de-c4a2-4c13-aa93-730a9e878ab7", // Shreya UAT
  "2D5A7AD9-862B-40C9-A0A1-790CD315D0F1", // Ray Cheng
  "c742cc7d-87d5-4a2f-881a-3f79add96cc1" // Prem SubtenantId 2  
]

export const getTodayDateUSFormat = () => {
  const today = new Date();

  const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const dd = String(today.getDate()).padStart(2, '0');
  const yyyy = today.getFullYear();

  return `${mm}/${dd}/${yyyy}`;
}

export const getTodayDateYYMMDD = () => {
  const today = new Date();
  const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const dd = String(today.getDate()).padStart(2, '0');
  const yyyy = today.getFullYear();

  return `${yyyy}-${mm}-${dd}`;
}

export const formatDateLocal = (dateInput) => {
  if (!dateInput) return '';

  const date = new Date(dateInput);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');

  return `${month}-${day}-${year}`;
};


export const formatDateLocalPST = (dateInput) => {
  if (!dateInput) return '';

  const date = new Date(dateInput);

  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const [month, day, year] = formatter.format(date).split('/');
  return `${month}-${day}-${year}`;
};

export const formatDateIntoUS = (inputDate) =>{
  const date = new Date(inputDate);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();
  
  return`${month}-${day}-${year}`;
  
  }

export function formatDateByZone(apiDate) {
    if (!apiDate) return '';
    var splitStringDateMap=apiDate.split("T")?.[0];
    console.log("99fwedsc",splitStringDateMap)
    const [y, m, d] = splitStringDateMap.split("-");
    return `${m}-${d}-${y}`
  }

// Returns the correct target date based on selected month/year
// - Past month: last day of that month (YYYY-MM-DD or MM/DD/YYYY)
// - Current month: yesterday (or 1st of current month if yesterday rolled into previous month)
export const getTargetDate = (selectedMonth, selectedYear, format = 'YYYY-MM-DD') => {
  const today = new Date();
  const currentRealMonth = today.getMonth() + 1;
  const isPastMonth = Number(selectedMonth) !== currentRealMonth || Number(selectedYear) !== today.getFullYear();

  let targetDate;
  if (isPastMonth) {
    targetDate = new Date(selectedYear, selectedMonth, 0); // last day of selected month
  } else {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    targetDate = yesterday.getMonth() !== today.getMonth()
      ? new Date(today.getFullYear(), today.getMonth(), 1)
      : yesterday;
  }

  const yyyy = targetDate.getFullYear();
  const mm = String(targetDate.getMonth() + 1).padStart(2, '0');
  const dd = String(targetDate.getDate()).padStart(2, '0');

  return format === 'MM/DD/YYYY' ? `${mm}/${dd}/${yyyy}` : `${yyyy}-${mm}-${dd}`;
};
